import { render } from "./FranchiseContact.vue?vue&type=template&id=56492b80&scoped=true&ts=true"
import script from "./FranchiseContact.vue?vue&type=script&lang=ts"
export * from "./FranchiseContact.vue?vue&type=script&lang=ts"

import "./FranchiseContact.vue?vue&type=style&index=0&id=56492b80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56492b80"]])

export default __exports__